import { ReportStatus } from 'src/graphql';
import {
  closedColorResolver,
  defaultColorResolver,
  draftColorResolver,
  newColorResolver,
  pendingColorResolver,
  pendingMitigationColorResolver,
  type ColorResolver,
  underReviewColorResolver,
} from './sharedStatusColorResolvers';

const STATUS_COLOR_RESOLVERS: Record<string, ColorResolver> = {
  [ReportStatus.Draft]: draftColorResolver,
  [ReportStatus.New]: newColorResolver,
  [ReportStatus.Read]: underReviewColorResolver,
  [ReportStatus.Investigating]: pendingMitigationColorResolver,
  [ReportStatus.Closed]: closedColorResolver,
  [ReportStatus.Lodged]: pendingColorResolver,
};

export const SpeakUpStatusColorMap = (status?: string): ColorResolver =>
  STATUS_COLOR_RESOLVERS[status?.toUpperCase() ?? ''] ?? defaultColorResolver;
